query GetCharity($id: ID!) {
  charity(id: $id) {
    id
    name
    status
    charityHqCountry
    website
    candidProfileUrl
    notes
    fiscalYearEnd
    currency
    salesforceId
    charityCompanyNumber
    usDueDiligences {
      id
      createdAt
    }
    legacyDueDiligences {
      salesforceId
      createdAt
    }
    grantsFromFpDafs {
      caseNumber
      transactionDate
      senderAmount {
        minorUnit
        currency
      }
      senderName
    }
    grantsFromFpFunds {
      caseNumber
      transactionDate
      senderAmount {
        minorUnit
        currency
      }
      senderName
    }
  }
}
